// extracted by mini-css-extract-plugin
export default {"gigg-watermark":"GiggWatermark_gigg-watermark__cyCf1","animate":"GiggWatermark_animate__F-7sJ","grow":"GiggWatermark_grow__xi0QN"};